/* eslint-disable global-require */
import angular from 'angular';

import OfferFormController from './offer-form.controller';
import OfferFormService from './offer-form.helper';

export default angular.module('autoboard.formOffer', [])
  .directive('formOffer', () => {
    'ngInject';

    return {
      controller: OfferFormController,
      controllerAs: '$ctrl',
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
        customerId: '<?',
        dummyVehicle: '=?',
      },
      templateUrl: require('./offer-form.template.html'),
    };
  })
  .service('offerFormService', OfferFormService)
  .name;
